import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { ToolbarModule } from 'primeng/toolbar';
import { CardModule } from 'primeng/card';
import { CommonModule } from '@angular/common';
import { UserModel } from '@tsin-core/models/auth.model';
import { AuthState } from '@tsin-core/states/auth.state';
import { Observable, take } from 'rxjs';
import { Store } from '@ngxs/store';
import { LogoutAction } from '@tsin-core/actions/auth.action';
import { environment } from '@tsin-env/environment';
import { Router } from '@angular/router';
import { MenuService } from '@tsin-core/services/common/menu.service';

@Component({
  selector: 'app-main-header',
  standalone: true,
  imports: [
    CommonModule,
    AvatarModule,
    ButtonModule,
    ToolbarModule,
    CardModule,
  ],
  templateUrl: './main-header.component.html',
  styleUrl: './main-header.component.scss',
})
export class MainHeaderComponent {
  store: Store = inject(Store);
  router: Router = inject(Router);
  authState$: Observable<UserModel | null> = this.store
    .select(AuthState.getCurrentUser)
    .pipe(take(1));
  loading$: Observable<boolean> = this.store.select(AuthState.isLoading);
  menuService: MenuService = inject(MenuService);

  showNotifications: boolean = false;

  notifications: [] = [];

  goToMainPage() {
    const user = this.store.selectSnapshot(AuthState.getCurrentUser);

    if (['Examiner', 'Standardized-client'].includes(user?.role!)) {
      this.router.navigate(['casual-staff']);
      return;
    }

    if (['superAdmin', 'admin', 'examAdmin'].includes(user?.role!)) {
      this.router.navigate(['management/select-programs']);
      return;
    }

    this.router.navigate(['user/select-account']);
  }

  toggleDarkMode() {
    const element = document.querySelector('html');
    element!.classList.toggle('my-app-dark');

    // if (element && element.classList.contains('my-app-dark')) {
    //   this.iconTheme = '';
    // } else {
    //   this.iconTheme = '';
    // }
  }

  toggleNotifications() {
    this.showNotifications = !this.showNotifications;
  }

  toggleMenu() {
    this.menuService.toggleMenu(!this.menuService.visible());
  }

  logout() {
    // write logout logic
    this.store.dispatch(new LogoutAction());
    window.location.href = environment.userMgtUrl;
    return;
  }
}
